import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { Expression } from "abreact/expression/Expression";
import { ExpExpressionNodeNodeTypeEnum } from "abweb/generated/abwebinternal/api/dto/ExpExpressionNode";
export class SimpleSummaryExpressionDefinitionExportVisitorImpl {
  constructor(summaryGenerator, expressionDomainModel) {
    _defineProperty(this, "_summaryGenerator", void 0);
    _defineProperty(this, "_expressionDomainModel", void 0);
    _defineProperty(this, "_currentConditionGroup", undefined);
    _defineProperty(this, "_singleSummary", undefined);
    this._summaryGenerator = summaryGenerator;
    this._expressionDomainModel = expressionDomainModel;
  }
  finalizeExpExpressionDefinition(expExpressionDefinition) {
    if (this._currentConditionGroup) {
      let summary = this._currentConditionGroup.generateSummary("").join(" ");
      this._currentConditionGroup = undefined;
      expExpressionDefinition.description = summary;
    } else if (this._singleSummary) {
      expExpressionDefinition.description = this._singleSummary;
      this._singleSummary = undefined;
    }
  }
  finalizeRootExpExpressionNode(expExpressionNode) {
    if (this._currentConditionGroup) {
      expExpressionNode.description = this._currentConditionGroup.generateSummary("").join(" ");
    } else if (this._singleSummary) {
      expExpressionNode.description = this._singleSummary;
    }
  }
  startJoinExpExpressionNode(expExpressionNode) {
    const jointType = expExpressionNode.nodeType === ExpExpressionNodeNodeTypeEnum.ACTION_LIST ? "," : expExpressionNode.operatorID;
    if (!this._currentConditionGroup) {
      this._currentConditionGroup = new ConditionGroup(undefined, jointType);
    } else {
      let newGroup = new ConditionGroup(this._currentConditionGroup, jointType);
      this._currentConditionGroup.subGroups.push(newGroup);
      this._currentConditionGroup = newGroup;
    }
  }
  visitRowExpExpressionNode(expExpressionNode, _rowModel) {
    const summary = this._summaryGenerator.createStringConditionSummary(expExpressionNode, Expression.Domain.Constants.FUNCTION_SUMMARY_STANDARD, this._expressionDomainModel, true);
    expExpressionNode.description = summary;
    // capture just in case this is the only condition (lacking AND/OR group at root)
    this._singleSummary = summary;
    this._currentConditionGroup?.conditionSummaries.push(summary);
  }
  endJoinExpExpressionNode(expExpressionNode) {
    if (this._currentConditionGroup?.parentGroup) {
      this._currentConditionGroup = this._currentConditionGroup.parentGroup;
    }
  }
}
class ConditionGroup {
  constructor(parentGroup, jointType) {
    _defineProperty(this, "_parentGroup", void 0);
    _defineProperty(this, "_jointType", void 0);
    _defineProperty(this, "_conditionSummaries", []);
    _defineProperty(this, "_subGroups", []);
    this._jointType = jointType ? jointType : "";
    this._parentGroup = parentGroup;
  }
  get parentGroup() {
    return this._parentGroup;
  }
  get conditionSummaries() {
    return this._conditionSummaries;
  }
  get subGroups() {
    return this._subGroups;
  }
  generateSummary(indent) {
    let joinTypeToShow = this.parentGroup ? this._jointType + " " : "";
    const summaryLines = [];
    for (const conditionSummary of this._conditionSummaries) {
      summaryLines.push(`${indent}${joinTypeToShow}${conditionSummary}`);
      joinTypeToShow = this._jointType + " ";
    }
    for (const conditionGroup of this.subGroups) {
      summaryLines.push(...conditionGroup.generateSummary(indent));
    }
    return summaryLines;
  }
}
//# sourceMappingURL=SimpleSummaryExpressionDefinitionExportVisitorImpl.js.map
